/**
 * As duas origens de feedback, lado a lado na faixa da tela: o dos clientes,
 * pelo botão do site novo, e o da equipe, pelo botão flutuante do Sistema.
 *
 * Moram no título da faixa, e não numa barra própria: uma faixa de comando por
 * tela é a regra 1 da padronização.
 */

import { useQuery } from "@tanstack/react-query"
import { listarFeedbacksDoSistema } from "@/api/feedbackDoSistema"

export type AbaDoFeedback = "clientes" | "equipe"

export function AbasDoFeedback({ aba, aoTrocar }: { aba: AbaDoFeedback; aoTrocar: (a: AbaDoFeedback) => void }) {
  // Quantos da equipe estão esperando: o número na aba é o que faz alguém abri-la.
  const abertos = useQuery({
    queryKey: ["feedback-sistema", "", "abertos", 1] as const,
    queryFn: () => listarFeedbacksDoSistema({ situacao: "abertos", pagina: 1 }),
    staleTime: 60_000,
  })
  const pendentes = abertos.data?.contagem.abertos ?? 0

  return (
    <div
      role="tablist"
      aria-label="Origem do feedback"
      style={{
        display: "inline-flex", padding: 3, gap: 2, borderRadius: 9,
        background: "var(--surface3)", verticalAlign: "middle",
      }}
    >
      <Aba ligada={aba === "clientes"} aoClicar={() => aoTrocar("clientes")}>Clientes do Diagweb</Aba>
      <Aba ligada={aba === "equipe"} aoClicar={() => aoTrocar("equipe")}>
        Equipe do Sistema
        {pendentes > 0 && (
          <span
            className="num"
            aria-label={`${pendentes} abertos`}
            style={{
              minWidth: 18, height: 18, padding: "0 5px", borderRadius: 999,
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              background: "var(--acao)", color: "var(--acao-ink)", fontSize: 10.5, fontWeight: 700,
            }}
          >
            {pendentes}
          </span>
        )}
      </Aba>
    </div>
  )
}

function Aba({ ligada, aoClicar, children }: { ligada: boolean; aoClicar: () => void; children: React.ReactNode }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={ligada}
      onClick={aoClicar}
      style={{
        display: "inline-flex", alignItems: "center", gap: 7, height: 28, padding: "0 12px",
        borderRadius: 7, fontSize: 12.5, fontWeight: ligada ? 600 : 500,
        color: ligada ? "var(--txt)" : "var(--txt2)",
        background: ligada ? "var(--surface)" : "transparent",
        boxShadow: ligada ? "var(--sombra)" : "none",
        transition: "background .15s ease, color .15s ease",
      }}
    >
      {children}
    </button>
  )
}
